import * as React from "react";
import { Router } from "react-router-dom";
import { Provider } from "mobx-react";
import { CookiesProvider } from "react-cookie";
import { isMobileSafari } from "react-device-detect";
import { List, Avatar, Icon, Typography } from "antd";
// Shared components
import Button from "components/Button";
import PublicRoute from "components/PublicRoute";
import PrivateRoute from "components/PrivateRoute";
// Local components
import Auth from "screens/Auth";
import Activate from "screens/Auth/screens/Activate";
import Home from "screens/Home";
import Dashboard from "screens/Dashboard";
import BankResult from "screens/Dashboard/screens/Bank";
// Utilities and hooks
import { get } from "lodash";
import appState from "./state";
import history from "helpers/history";
import { read, store } from "helpers/localStorage";
import useUser from "hooks/useUser";
import GeneralService from "services/http/endpoints/general";
// Styles
import Logo from "assets/images/baazar.png";
import "./styles/app.scss";

const data = [
	{
		title: "‫دکمه Share را در نوار پایین کلیک کنید.",
		avatar: <img src="/pwa-share.svg" alt="share" width="12px" />,
	},
	{
		title: "گزینه Add to Home Screen را انتخاب کنید.",
		avatar: <img src="/pwa-plus.svg" alt="plus" width="13px" />,
	},
	{
		title: "در قسمت بالا روی Add کلیک کنید.",
		avatar: <Avatar style={{ color: "#0775ee", backgroundColor: "#fff" }}>Add</Avatar>,
	},
];

const { Title, Text } = Typography;

const App: React.FC = () => {
	const user = useUser();
	const [, updateState] = React.useState();
	const forceUpdate = React.useCallback(() => updateState({}), []);

	const isInStandaloneMode = (): any => {
		// Detects if device is in standalone mode
		if ("standalone" in window.navigator) {
			return get(window.navigator, ["standalone"]);
		}
	};

	const getVersion = async () => {
		try {
			const result = await GeneralService.ver();
			appState.setVersion(result);
		} catch (error) {
			//
		}
	};

	const addToHomeScreen = () => {
		store("add-to-home-screen-visited", true);
		forceUpdate();
	};

	React.useEffect(() => {
		getVersion();
		user.getUserInfo();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Provider {...appState.stores()}>
			<CookiesProvider>
				{isMobileSafari && !isInStandaloneMode() && !read("add-to-home-screen-visited") ? (
					<div style={{ textAlign: "center", padding: "48px 32px" }}>
						<img src={Logo} alt="سامانه بازر" height="64" style={{ marginBottom: "12px" }} />
						<Title level={3}>افزودن وب اپلیکیشن بازر</Title>
						<Text>با این کار می‌توانید به آسانی از خدمات بازر استفاده کنید.</Text>
						<List
							style={{ marginTop: "32px", textAlign: "justify" }}
							itemLayout="horizontal"
							dataSource={data}
							renderItem={item => (
								<List.Item>
									<List.Item.Meta
										avatar={<div style={{ width: 50 }}>{item.avatar}</div>}
										title={item.title}
									/>
								</List.Item>
							)}
						/>
						<Button block type="primary" size="large" onClick={addToHomeScreen}>
							متوجه شدم
						</Button>
						<Icon type="arrow-down" className="bounce" style={{ fontSize: "2em", marginTop: "2em" }} />
					</div>
				) : (
					<Router history={history}>
						<div className="App">
							<PublicRoute restricted={false} exact path="/" component={Home} />
							<PublicRoute restricted path="/auth" component={Auth} />
							<PublicRoute path="/activate" component={Activate} />
							<PublicRoute path="/payment-result/:status" component={BankResult} />
							<PrivateRoute path="/dashboard" component={Dashboard} />
						</div>
					</Router>
				)}
				{/* <Offline>
					<Result
						status="500"
						title="خطا در اتصال به اینترنت"
						subTitle="تنظیمات شبکه خود را بررسی کنید."
						extra={
							<Button type="primary" onClick={forceUpdate}>
								تلاش مجدد
							</Button>
						}
					/>
				</Offline> */}
			</CookiesProvider>
		</Provider>
	);
};

export default App;
